"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FinanceSummary_1 = require("./FinanceSummary");
var useFinancePackageFrequencyLabelProvider_1 = require("../../../common/react/useFinancePackageFrequencyLabelProvider");
var FinanceSummaryWrapper = function (_a) {
    var fcConfig = _a.fcConfig, language = _a.language, carConfiguration = _a.carConfiguration, financeQuote = _a.financeQuote, isCashDeal = _a.isCashDeal, isMultiCurrency = _a.isMultiCurrency, primaryTotalPrice = _a.primaryTotalPrice, secondaryTotalPrice = _a.secondaryTotalPrice, totalAmountFinanced = _a.totalAmountFinanced, handleErrors = _a.handleErrors;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var financePackageFrequencyLabelProvider = useFinancePackageFrequencyLabelProvider_1.default();
    return (carConfiguration && (<FinanceSummary_1.default fcConfig={fcConfig} language={language} carConfiguration={carConfiguration} financeDetails={{
        interestRate: (_b = financeQuote) === null || _b === void 0 ? void 0 : _b.interestRate,
        currency: (_c = financeQuote) === null || _c === void 0 ? void 0 : _c.currency,
        duration: (_d = financeQuote) === null || _d === void 0 ? void 0 : _d.duration,
        frequency: financePackageFrequencyLabelProvider((_e = financeQuote) === null || _e === void 0 ? void 0 : _e.packageCode, 'long'),
        primary: {
            value: (_f = financeQuote) === null || _f === void 0 ? void 0 : _f.monthlyPayment,
            currency: (_g = financeQuote) === null || _g === void 0 ? void 0 : _g.currency,
        },
        secondary: ((_h = financeQuote) === null || _h === void 0 ? void 0 : _h.secondaryCurrencyQuote) ? {
            value: (_j = financeQuote) === null || _j === void 0 ? void 0 : _j.secondaryCurrencyQuote.monthlyPayment,
            currency: (_k = financeQuote) === null || _k === void 0 ? void 0 : _k.secondaryCurrencyQuote.currency,
        }
            : null,
    }} financeQuoteToken={(_l = financeQuote) === null || _l === void 0 ? void 0 : _l.token} isCashDeal={isCashDeal} isMultiCurrency={isMultiCurrency} handleErrors={handleErrors} prices={{
        totalPayable: isCashDeal ? primaryTotalPrice : totalAmountFinanced,
        secondaryTotalPrice: secondaryTotalPrice,
    }}/>));
};
exports.default = FinanceSummaryWrapper;
